module.exports = __webpack_public_path__ + "static/img/02.12389d60.png";